import { TTrip } from "../types/TripTypes";
import moment from "moment";

export const  tripScheduleWarningMessage = (trips: TTrip[]) => {
  const newTrips: TTrip[] = [...trips];

  for (let i = 0; i < trips.length; i++) {
    const currentTrip = trips[i];

    // Skip trips with isWillCall set to true
    if (currentTrip.isWillCall) {
      continue;
    }

    const previousTrip = i > 0 ? trips[i - 1].isWillCall ? trips[i - (trips.length-1)] : trips[i - 1] : null;
    const nextTrip = i < trips.length - 1 ? trips[i + 1] : null;

    const currentScheduleTime =
      (currentTrip &&
        !currentTrip.isWillCall &&
        moment(currentTrip.scheduleTime, "h.mm A")) ||
      undefined;
    const previousScheduleTime =
      (previousTrip &&
        !previousTrip.isWillCall &&
        moment(previousTrip.scheduleTime, "h.mm A")) ||
      undefined;
    const nextScheduleTime =
      (nextTrip &&
        !nextTrip.isWillCall &&
        moment(nextTrip.scheduleTime, "h.mm A")) ||
      undefined;

    if (
      previousScheduleTime &&
      currentScheduleTime &&
      previousScheduleTime.isSameOrAfter(currentScheduleTime)
    ) {
      newTrips[i].areTimesChronological = true;
    } else if (
      !previousScheduleTime &&
      currentScheduleTime &&
      nextScheduleTime &&
      currentScheduleTime.isSameOrAfter(nextScheduleTime)
    ) {
      if (nextTrip) {
        newTrips[i + 1].areTimesChronological = true;
      }
    } else if (
      previousScheduleTime &&
      !currentScheduleTime &&
      nextScheduleTime &&
      previousScheduleTime.isSameOrAfter(nextScheduleTime)
    ) {
      if (i + 2 < trips.length) {
        newTrips[i + 2].areTimesChronological = true;
      }
    } else {
      newTrips[i].areTimesChronological = false;
    }
  }

  return newTrips;
};


